import { onMounted, useInstance, onUnmounted } from 'intact-vue';
export function useDelayClose(close, duration) {
  var instance = useInstance();
  var timer = null;
  function delayClose() {
    if (duration) {
      timer = window.setTimeout(close, duration);
    }
  }
  function onMouseEnter(e) {
    instance.trigger('mouseenter', e);
    clear();
  }
  function onMouseLeave(e) {
    instance.trigger('mouseleave', e);
    // mouse leave event is not a delegated event,
    // and it will not unmount when the dom has unmounted,
    // so we must detect the $unmounted status here
    if (instance.$unmounted) return;
    clear();
    delayClose();
  }
  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }
  onMounted(delayClose);
  onUnmounted(clear);
  return {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  };
}